import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * AdminRoute component - protects routes that require admin access
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if user is admin
 * @param {string} props.redirectTo - Path to redirect non-admin users (default: '/')
 */
export default function AdminRoute({ children, redirectTo = '/' }) {
  const { currentUser, authEnabled, isAdmin } = useAuth();

  // TEMPORARILY DISABLED: admin check commented out until functionality is stable
  // if (!authEnabled || !currentUser || !isAdmin) {
  //   return <Navigate to={redirectTo} replace />;
  // }

  return children;
}
